export const ra = {
  action: {
    update_application: "Update",
  },
  notification: {
    application_update_available: "A new version of the application is available. Please update.",
    "Failed to fetch": "Failed to fetch data. Please check your internet connection and try again later.",
  },
};
